import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const CrosshairAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM13 19.9V17C13 16.4 12.6 16 12 16C11.4 16 11 16.4 11 17V19.9C7.4 19.4 4.5 16.6 4.1 13H7C7.6 13 8 12.6 8 12C8 11.4 7.6 11 7 11H4.1C4.5 7.4 7.4 4.5 11 4.1V7C11 7.6 11.4 8 12 8C12.6 8 13 7.6 13 7V4.1C16.6 4.6 19.5 7.4 19.9 11H17C16.4 11 16 11.4 16 12C16 12.6 16.4 13 17 13H19.9C19.5 16.6 16.6 19.5 13 19.9ZM12 11C11.4 11 11 11.4 11 12C11 12.6 11.4 13 12 13C12.6 13 13 12.6 13 12C13 11.4 12.6 11 12 11Z"
      fill="currentColor"
    />
  </svg>
)

export default CrosshairAlt
